<template>
  <v-container>
    <div>Хайж буй хуудас олдсонгүй</div>
  </v-container>
</template>
<script>
export default {
  name: "NotFound"
};
</script>
<style scoped>
</style>